import { render, staticRenderFns } from "./missed-call-handler-popover.vue?vue&type=template&id=671d1df2&scoped=true"
import script from "./missed-call-handler-popover.vue?vue&type=script&lang=js"
export * from "./missed-call-handler-popover.vue?vue&type=script&lang=js"
import style0 from "./missed-call-handler-popover.vue?vue&type=style&index=0&id=671d1df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671d1df2",
  null
  
)

export default component.exports